function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border: 0;\n    border-left: 6px solid ", ";\n    border-radius: 4px;\n\n    :hover {\n      border-left: 6px solid ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
import { Card as BaseCard } from "@diana-ui/card";
var Card = styled(BaseCard)((_ref) => {
  var {
    theme
  } = _ref;
  return css(_templateObject(), theme.colors.grey.grey25, theme.colors.grey.grey25, theme.colors.blue.blue100);
});
export default Card;